/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Colleague_None_To_AddInputs */



/**
* | output |
* | --- |
* | "Wundo does not know any colleagues from your calendar yet." |
*
* @param {Meetings_Colleague_None_To_AddInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_colleague_none_to_add = /** @type {((inputs?: Meetings_Colleague_None_To_AddInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Colleague_None_To_AddInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo kent nog geen collega's uit je agenda.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo ne connaît encore aucun collègue dans votre agenda.")
	return /** @type {LocalizedString} */ ("Wundo does not know any colleagues from your calendar yet.")
});